import { amountToDisplayValue } from '@billy/design-system'
import isNumber from 'lodash/isNumber'

import { TransactionSide } from '@features/transactions/types/transactionSide'

export const getTransactionSideAmount = (amount: number | null, side: TransactionSide) => {
  if (!side || !isNumber(amount)) {
    return undefined
  }

  const amountToDisplay = amountToDisplayValue(amount).toString()

  if (amount === 0) {
    return amountToDisplay
  }

  return `${side === 'credit' ? '' : '-'}${amountToDisplay}`
}
